import "./style.css";

import ButtonListClass from "../../../components/Admin/ButtonListClass/ButtonListClass";
import { useEffect, useContext, useState } from "react";
import { HeaderTextContext } from "../../../contextAdmin/hederText";
import NewTable from "../../../components/Admin/NewTable/NewTable";
import React from "react";
import { studentDataContext } from "../../../contextAdmin/Admin/StudentData/index";
import { userContext } from "../../../contextAdmin/Admin/User/index";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import classRequets from "../../../components/api/classRequest";
import { calcCurrList } from "../../../functions/pagination";


const paginationSection = "studentsPagination"
// Creator : Team E - Chanan
function Students() {
  const location = useLocation()
  console.log("🚀 ~ file: Students.jsx:17 ~ Students ~ location:", location)
  const params = useParams()
  const NoPermission = useNavigate();
  const { setHeaderText } = useContext(HeaderTextContext);
  const { user } = useContext(userContext);


  const [usersDetails, setUsersDetails] = useState([])
  const [itemsPerPage, setItemsPerPage] = useState(7)
  const [paginationData, setPaginationData] = useState(usersDetails && usersDetails.length ? calcCurrList(usersDetails, localStorage[paginationSection] ? Number(localStorage[paginationSection]) : 1, 7) : { currentItems: [], totalPages: 1, pageToShow: 1 })

  let { setClassData } = useContext(studentDataContext);
  // const usersDetails = studentData.usersDetails;
  useEffect(() => {
    try {

      // classRequets.getOneTeacherClasses(params.class_id).then(res => {
      //   setUsersDetails(res.data?.students)
      //   setHeaderText("classroom # " + res.data?.classroomId);
      //   })
      setUsersDetails(location.state?.students.sort((a, b) => a.id - b.id))
      setHeaderText("classroom #" + location.state?.classroomId);
      setClassData(location.state)
    } catch (error) {
      console.log("🚀 ~ file: Students.jsx:55 ~ useEffect ~ error:", error)
    }


    return () => {
    }
  }, []);

  useEffect(() => {
    if (usersDetails.length) {
      let pageToShow = Math.ceil(usersDetails.length / itemsPerPage) > paginationData.totalPages ? paginationData.totalPages + 1 : paginationData.pageToShow//check if the new user is in new page
      let CurrentToShow = calcCurrList(usersDetails, localStorage[paginationSection] ? Number(localStorage[paginationSection]) : paginationData.pageToShow, itemsPerPage)
      setPaginationData(CurrentToShow)
    }
  }, [usersDetails])

  useEffect(() => {
    if (usersDetails.length) {
      let CurrentToShow = calcCurrList(usersDetails, paginationData.pageToShow, itemsPerPage)
      setPaginationData(CurrentToShow)

    }
  }, [paginationData.pageToShow])

  return (
    <div className="container">
      {paginationData.totalPages > 1 &&
        <div className="buttonListClass">
          <ButtonListClass
            pageActive={paginationData.pageToShow}
            totalPages={paginationData.totalPages}
            setPaginationData={setPaginationData}
            from={paginationSection}
          />
        </div>
      }
      <div className="mainTablee">
        <NewTable currList={paginationData.currentItems} typ={"student"} />
      </div>
    </div >
  );
}

export default Students;
